/*!
 * devextreme-angular
 * Version: 16.2.5
 * Build date: Tue Feb 28 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var core_1 = require('@angular/core');
var nested_option_1 = require('../../core/nested-option');
var nested_option_2 = require('../../core/nested-option');
var DxoGroupPanelComponent = (function (_super) {
    __extends(DxoGroupPanelComponent, _super);
    function DxoGroupPanelComponent(parentOptionHost, optionHost) {
        _super.call(this);
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    Object.defineProperty(DxoGroupPanelComponent.prototype, "allowColumnDragging", {
        get: function () {
            return this._getOption('allowColumnDragging');
        },
        set: function (value) {
            this._setOption('allowColumnDragging', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoGroupPanelComponent.prototype, "emptyPanelText", {
        get: function () {
            return this._getOption('emptyPanelText');
        },
        set: function (value) {
            this._setOption('emptyPanelText', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoGroupPanelComponent.prototype, "visible", {
        get: function () {
            return this._getOption('visible');
        },
        set: function (value) {
            this._setOption('visible', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoGroupPanelComponent.prototype, "_optionPath", {
        get: function () {
            return 'groupPanel';
        },
        enumerable: true,
        configurable: true
    });
    DxoGroupPanelComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'dxo-group-panel',
                    template: '',
                    styles: [''],
                    providers: [nested_option_1.NestedOptionHost]
                },] },
    ];
    DxoGroupPanelComponent.ctorParameters = function () { return [
        { type: nested_option_1.NestedOptionHost, decorators: [{ type: core_1.SkipSelf }, { type: core_1.Host },] },
        { type: nested_option_1.NestedOptionHost, decorators: [{ type: core_1.Host },] },
    ]; };
    DxoGroupPanelComponent.propDecorators = {
        'allowColumnDragging': [{ type: core_1.Input },],
        'emptyPanelText': [{ type: core_1.Input },],
        'visible': [{ type: core_1.Input },],
    };
    return DxoGroupPanelComponent;
}(nested_option_2.NestedOption));
exports.DxoGroupPanelComponent = DxoGroupPanelComponent;
var DxoGroupPanelModule = (function () {
    function DxoGroupPanelModule() {
    }
    DxoGroupPanelModule.decorators = [
        { type: core_1.NgModule, args: [{
                    declarations: [
                        DxoGroupPanelComponent
                    ],
                    exports: [
                        DxoGroupPanelComponent
                    ],
                },] },
    ];
    DxoGroupPanelModule.ctorParameters = function () { return []; };
    return DxoGroupPanelModule;
}());
exports.DxoGroupPanelModule = DxoGroupPanelModule;
//# sourceMappingURL=group-panel.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/devextreme-angular/ui/nested/group-panel.js
// module id = ../../../../devextreme-angular/ui/nested/group-panel.js
// module chunks = 3